'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessagesUtk = undefined;

var _reselect = require('reselect');

var _getMessagesUtk = require('../operators/getMessagesUtk');

var _getVisitorIdentity = require('./getVisitorIdentity');

var getMessagesUtk = exports.getMessagesUtk = (0, _reselect.createSelector)(_getVisitorIdentity.getVisitorIdentity, function (visitorIdentity) {
  return (0, _getMessagesUtk.getMessagesUtk)(visitorIdentity);
});